/**
 * @generated SignedSource<<79873335f3bf0a9db18457d0699a4c82>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpAdditionalContent_nftItem$data = {
  readonly additionalInfo: {
    readonly copy: string | null;
    readonly imageList: ReadonlyArray<{
      readonly height: string | null;
      readonly url: string | null;
      readonly width: string | null;
    } | null> | null;
    readonly imageListCaption: string | null;
    readonly videoEmbed: string | null;
    readonly videoEmbedCaption: string | null;
  } | null;
  readonly " $fragmentType": "NftPdpAdditionalContent_nftItem";
};
export type NftPdpAdditionalContent_nftItem$key = {
  readonly " $data"?: NftPdpAdditionalContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpAdditionalContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpAdditionalContent_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItemCmsLoader",
      "kind": "LinkedField",
      "name": "additionalInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "copy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoEmbed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoEmbedCaption",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftItemCmsImage",
          "kind": "LinkedField",
          "name": "imageList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageListCaption",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "2c2bb0e0d152ba47137ca51e29576939";

export default node;
